import { Controller } from "@hotwired/stimulus"

// Toggles decay/develop labels and help text based on polarity selection
export default class extends Controller {
  static targets = ["legend", "description", "floorHelp", "ceilingHelp", "floorField", "ceilingField"]

  connect() {
    this.update()
  }

  update() {
    const isInverse = this.element.querySelector('input[name*="polarity"][value="inverse"]')?.checked

    this.legendTarget.textContent = isInverse ? "Develop Settings" : "Decay Settings"
    this.descriptionTarget.textContent = isInverse
      ? "Automatically increase this liability over time (e.g., Heat builds up)."
      : "Automatically decrease this resource over time (e.g., Food spoils)."
    this.floorHelpTarget.textContent = isInverse
      ? "Not used for liabilities (develops upward)."
      : "Minimum value decay can reach. Default: 1."
    this.ceilingHelpTarget.textContent = isInverse
      ? "Maximum value develop can reach. Defaults to scale max."
      : "Not used for resources (decays downward)."

    this.floorFieldTarget.disabled = isInverse
    this.floorFieldTarget.closest(".mb-3").style.opacity = isInverse ? "0.4" : "1"

    this.ceilingFieldTarget.disabled = !isInverse
    this.ceilingFieldTarget.closest(".mb-3").style.opacity = !isInverse ? "0.4" : "1"
  }
}
